import React from "react";
import styles from "./continue-button.module.css";
import {useSelector} from "react-redux";
import { getPaywallPage } from "src/shared/utils/get-paywall-page";
import { removeLocalStorage, StorageKey } from "src/shared/utils/localStorages";

const ContinueButton = () => {
  const guestId = useSelector((store) => store.guestId);
  // const resultLink = `https://front-dev.zodiaq.vip/horoscopes?userId=${guestId}&source=tarot-chat`;
  // TODO брать аргумент для getPaywallPage из LS
  const paywallPage = getPaywallPage('tarot-chat')
  const resultLink = `https://zodiaq.vip/${paywallPage}?userId=${guestId}&source=tarot-chat`;

  const handleContinue = () => {
    removeLocalStorage(StorageKey.UserId);
  };

  return (
   <a className={styles.button} href={resultLink} onClick={handleContinue}>See the answer →</a>
  );
}

export { ContinueButton };
